import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ServiceProvider } from '@wsphere/service-providers/domain';

/** Hands the page the provider the guard already fetched. */
@Injectable()
export class ServiceProviderResolver implements Resolve<ServiceProvider.Model | null> {
  serviceProvider: ServiceProvider.Model | null = null;

  async resolve(): Promise<ServiceProvider.Model | null> {
    return this.serviceProvider;
  }
}
